import { AxiosResponse, AxiosResponseHeaders } from "axios";
import api from "./index";
import { PaymentListItem, PaymentListItemHall } from "../components/Halls/Form/interface";

export const payoutApi = api.injectEndpoints({
    endpoints: (builder) => ({
        findPayments: builder.query<Payment[], WithPagination<PaymentFormFind>>({
            query: (form) => {
                const params: Record<string, string> = {};
                if (form.data) {
                    let k: keyof PaymentFormFind;
                    for (k in form.data) {
                        if (k && form.data[k]) {
                            if (Array.isArray(form.data[k])) {
                                const x: number[] = form.data[k] as number[];
                                for (let idx in x) {
                                    params[`f[${k}][${idx}]`] = x[idx].toString();
                                }
                            } else {
                                params[`f[${k}]`] = form.data[k]!.toString();
                            }
                        }
                    }
                }
                return { url: `hall/payment?${new URLSearchParams(params).toString()}`, method: "get" };
            },
            transformResponse: (response: any) => response.data,
            providesTags: (_result, _error, args) => [{ type: "payments", id: args.data!.hall_id }],
        }),
        findPayouts: builder.query<ResponseWithPagination<Payment[]>, WithPagination<PaymentFormFind>>({
            query: (form) => {
                const params: Record<string, string> = {};
                if (form.data) {
                    let k: keyof PaymentFormFind;
                    for (k in form.data) {
                        if (k && form.data[k]) {
                            if (Array.isArray(form.data[k])) {
                                const x: number[] = form.data[k] as number[];
                                for (let idx in x) {
                                    params[`f[${k}][${idx}]`] = x[idx].toString();
                                }
                            } else {
                                params[`f[${k}]`] = form.data[k]!.toString();
                            }
                        }
                    }
                }
                return { url: `hall/payment?${new URLSearchParams(params).toString()}&page=${form.page ?? 1}`, method: "get" };
            },
            transformResponse: (response: any, meta: AxiosResponse<any, any>) => {
                const headers = meta.headers as AxiosResponseHeaders;
                return {
                    data: response.data as Payment[],
                    pagination: {
                        currentPage: +(headers.get("x-pagination-current-page") ?? 1),
                        pageCount: +(headers.get("X-Pagination-Page-Count") ?? 1),
                        perPage: +(headers.get("X-Pagination-Per-Page") ?? 20),
                        totalCount: +(headers.get("X-Pagination-Total-Count") ?? 1),
                    }
                };
            },
            providesTags: (_result, _error, args) => [{ type: "payments", id: args.data!.hall_id }],
        }),
        confirmPayout: builder.mutation<DefaultResponse<boolean>, BankCardRequestId>({
            query: (request) => ({ url: `hall/payment/confirm/${request.id}`, method: "post" }),
            invalidatesTags: (_result, _error, args) => [{ type: "payments", id: args.hall_id }],
        }),
        cancelPayout: builder.mutation<DefaultResponse<boolean>, BankCardRequestId>({
            query: request => ({ url: `hall/payment/cancel/${request.id}`, method: "post" }),
            invalidatesTags: (_result, _error, args) => [{ type: "payments", id: args.hall_id }],
        }),
        processPayout: builder.mutation<DefaultResponse<boolean>, BankCardRequestId>({
            query: request => ({ url: `hall/payment/process/${request.id}`, method: "post" }),
            invalidatesTags: (_result, _error, args) => [{ type: "payments", id: args.hall_id }],
        }),
        config: builder.query<DefaultResponse<PaymentListItem[]>, void>({
            query: () => ({ url: `hall/payment/config` }),
        }),
        hallConfig: builder.query<DefaultResponse<PaymentListItemHall[]>, number>({
            query: hallId => ({ url: `hall/payment/hall-config/${hallId}` }),
            providesTags: (_result, _error, hallId) => [{ type: "hall-config", id: hallId }],
        }),
    }),
});

export const { useFindPayoutsQuery, useCancelPayoutMutation, useConfirmPayoutMutation, useProcessPayoutMutation, useFindPaymentsQuery, useConfigQuery, useHallConfigQuery } = payoutApi;